import React, { useState } from 'react'
import { Form, Select, Input, Button, Space, Divider, Upload } from 'antd'
import { useUserContext } from '../../contexts/UserContext';
import companyService from '../../services/companyService';
import Typography from 'antd/es/typography/Typography';
import { UploadOutlined } from '@ant-design/icons';


const AddCompanyForm = ({ form, handleClose, messageApi, messageKey, fetchCompanies }) => {

  const { id } = useUserContext()
  const [imageName, setImageName] = useState('')

  const handleAddCompany = (values) => {
    const {prefix, contactNumber, ...rest} = values
    console.log(prefix+contactNumber)
    messageApi.open({
      key: messageKey,
      type: 'loading',
      content: 'Adding Company...',
      duration: 0
    })
    companyService.createCompany({ ...rest, contactNumber: prefix+'-'+contactNumber, consultantId: id })
      .then((response) => {
        messageApi.open({
          key: messageKey,
          type: 'success',
          content: 'Company successfully added!'
        })
        fetchCompanies(id)
        handleClose()
      })
      .catch((error) => {
        messageApi.open({
          key: messageKey,
          type: 'error',
          content: 'Error adding company!'
        })
      })
  }

  const fileToBase64 = (e) => {
    const file = e.file.originFileObj
    setImageName(e.file.name)
    const reader = new FileReader();
    reader.onload = (event) => {
      const base64String = event.target.result;
      form.setFieldsValue({ companyImage: base64String })
    };
    reader.readAsDataURL(file);
  }

  const prefixSelector = (
    <Form.Item name="prefix" noStyle>
      <Select style={{ width: 70 }}>
        <Select.Option value="+92">+92</Select.Option>
        <Select.Option value="+1">+1</Select.Option>
      </Select>
    </Form.Item>
  );

  return (
    <Form
      name='add-company-form'
      form={form}
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 14 }}
      initialValues={{ prefix: '+92' }}
      requiredMark={false}
      layout="horizontal"
      onFinish={handleAddCompany}
      // style={{ maxWidth: 600 }}
    >
      <Form.Item style={{marginTop: 24}} 
        label='Company Name' 
        name='companyName'
        rules={[{ required: true, message: 'Please enter company name' }]}
      >
        <Input type='text' />
      </Form.Item>
      <Form.Item label='Industry' name='industry'
        rules={[{ required: true, message: 'Please enter industry' }]}
      >
        <Input type='text' />
      </Form.Item>
      <Form.Item label="Strength" name='strength'
        rules={[{ required: true, message: 'Please select company strength' }]}
      >
        <Select placeholder='select'>
          <Select.Option value="1-10">1-10</Select.Option>
          <Select.Option value="10-50">10-50</Select.Option>
          <Select.Option value="50-100">50-100</Select.Option>
          <Select.Option value="100-200">100-200</Select.Option>
          <Select.Option value="200-500">200-500</Select.Option>
          <Select.Option value="500 & more">500 & more</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item label="Image" name='companyImage' valuePropName='file' getValueFromEvent={fileToBase64}
        // rules={[{ required: true, message: 'Please upload company image' }]}
      >
        <Upload
          customRequest={() => {}}
          listType="picture"
          maxCount={1}
          showUploadList={false}
          >
          <Space style={{ alignItems: 'flex-start' }}>
            <Button icon={<UploadOutlined />}>Upload</Button>
            <Typography.Text>{imageName}</Typography.Text>
          </Space>
        </Upload>
      </Form.Item>
      <Divider/>
      {/* <Typography.Title level={5}>
        Contact Person Info
      </Typography.Title> */}
      <Form.Item style={{marginTop: 24}} 
        label='Contact Person' 
        name='personName'
        rules={[{ required: true, message: 'Please enter contact person name' }]}
      >
        <Input type='text' />
      </Form.Item>
      <Form.Item style={{marginTop: 24}} 
        label='Designation' 
        name='designation'
        rules={[{ required: true, message: 'Please enter designation' }]}
      >
        <Input type='text' />
      </Form.Item>
      <Form.Item label="Email" name="email"
        rules={[{ required: true, message: 'Please enter email' }]}
      >
        <Input type='email' />
      </Form.Item>
      <Form.Item
        name="contactNumber"
        label="Contact Number"
        rules={[{ required: true, message: 'Please enter contact number' }]}
      >
        <Input addonBefore={prefixSelector} style={{ width: '100%' }} />
      </Form.Item>


      <Form.Item style={{marginTop: 32}} wrapperCol={{ offset: 6, span: 14 }}>
        <Space>
          <Button type='primary' htmlType='submit'>Add</Button>
          <Button type='default' onClick={() => {
            setImageName('')
            handleClose()
          }}>Cancel</Button>
        </Space>
      </Form.Item>
    </Form>
  )
}

export default AddCompanyForm